import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import AddPage from './pages/AddPage';
import EditPage from './pages/EditPage';
import HomePage from './pages/HomePage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/add" element={<AddPage />} />
        <Route path="/edit/:bookId" element={<EditPage />} />
      </Routes>
    </Router>
  );
}

export default App;
